import ContentSection from "../ContentSections/ContentSection";
import GraphSection from "../ContentSections/GraphSection";
import LinksSection from "../ContentSections/LinksSection";
import TableSection from "../ContentSections/TableSection";
import LineChartSection from "../ContentSections/LineChartSection";
import MapSection from "../ContentSections/MapSection";
import {useEffect, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
import SearchHeroSection from "../ContentSections/SearchHeroSection";

function PageSections({sections}: any) {
    const [loadedSections, setLoadedSections] = useState<any>([]);
    const location = useLocation();
    const lastHash = useRef('');

    function onDataLoadHandler(sectionId: string)
    {
        setLoadedSections((prev: any) => [...prev, sectionId])
    }

    useEffect(() => {
        if (location.hash && loadedSections.includes(location.hash.slice(1))) {
            lastHash.current = location.hash.slice(1);

            const currentElement = lastHash.current ? document.getElementById(lastHash.current) : null;
            if (currentElement) {
                const headerHeight = document.querySelector('header')?.getBoundingClientRect()?.height ?? 0
                const top = currentElement.getBoundingClientRect().top - headerHeight;
                window.scrollTo({
                    behavior: 'smooth',
                    top: top,
                })

                lastHash.current = '';
            }
        }
    }, [loadedSections]);

    return (
        <>
            {sections.map((section: any, index: number) => {
                    switch (section.type) {
                        case 'links':
                            return <LinksSection key={index} content={section.content} />;
                        case 'content':
                            return <ContentSection key={index} content={section.content} isHero={index === 0} />;
                        case 'graph':
                            return <GraphSection key={index} content={section.content} id={`section-${index}`} onLoad={() => onDataLoadHandler(`section-${index}`)} />;
                        case 'table':
                            return <TableSection key={index} content={section.content} id={`section-${index}`} onLoad={() => onDataLoadHandler(`section-${index}`)} />;
                        case 'line-chart':
                            return <LineChartSection key={index} content={section.content} />;
                        case 'regions':
                            return <MapSection key={index} content={section.content} id={`section-${index}`} onLoad={() => onDataLoadHandler(`section-${index}`)} />;
                        case 'search-hero':
                            return <SearchHeroSection key={index} content={section.content} />;
                    }
                })
            }
        </>
    );
}

export default PageSections;